module.exports = __webpack_public_path__ + "static/feature_bg5-3605be35f7b7dbfac0e5ada9f4e03859.png";